import { useEffect, useState } from 'react';
import { animate, useReducedMotion } from 'framer-motion';
import { Card } from '@/shared/ui/card';

function CountUp({ value }: { value: number }) {
  const reduce = useReducedMotion();
  const [shown, setShown] = useState(reduce ? value : 0);
  useEffect(() => {
    if (reduce) {
      setShown(value);
      return;
    }
    const controls = animate(0, value, { duration: 0.9, ease: 'easeOut', onUpdate: (v) => setShown(Math.round(v)) });
    return () => controls.stop();
  }, [value, reduce]);
  return <>{shown.toLocaleString('pt-BR')}</>;
}

interface Props {
  indicated: number;
  registered: number;
  converted: number;
  earnedText: string | null;
}

/** Métricas do próprio participante (spec, seção 14, do lado dele). */
export function StatsStrip({ indicated, registered, converted, earnedText }: Props) {
  const tiles = [
    { label: 'Indicações', value: indicated },
    { label: 'Cadastros', value: registered },
    { label: 'Compraram', value: converted },
  ];
  return (
    <Card className="p-5">
      <div className="grid grid-cols-3 gap-2 text-center">
        {tiles.map((t) => (
          <div key={t.label}>
            <p className="text-2xl font-bold tabular-nums">
              <CountUp value={t.value} />
            </p>
            <p className="text-xs text-muted-foreground">{t.label}</p>
          </div>
        ))}
      </div>
      <div className="mgm-accent-soft mt-4 flex items-center justify-between rounded-xl px-4 py-3">
        <span className="text-sm font-medium">Você já ganhou</span>
        <span className="mgm-accent-text text-lg font-bold tabular-nums">{earnedText ?? 'nada ainda'}</span>
      </div>
    </Card>
  );
}
